import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ApiCallError } from "web_myplann/Infrastructure/Api/ApiUtils";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

export const useItemNotFoundRedirect = (error: unknown) => {
	const { t } = useResource();
	const navigate = useNavigate();

	const isNotFound = error instanceof ApiCallError && error.data.status === 404;

	useEffect(() => {
		if (!isNotFound) {
			return;
		}

		toast.error(t(Resources.Portfolio.Detail.notAvailable), {
			id: "portfolio-item-not-found",
		});
		navigate(Routing.Portfolio.PortfolioList.path(), { replace: true });
	}, [isNotFound, navigate, t]);

	return { isNotFound };
};
